// Scroll to section
window.addEventListener('load', () => {
  const navLinks = document.querySelectorAll('.person-info-list__filter-link');

  navLinks.forEach((link) => {
    const linkId = link.getAttribute('href');

    if (linkId && linkId !== '#') {
      const sectionElem = document.querySelector(linkId);

      if (sectionElem) {
        gsap.timeline({
          scrollTrigger: {
            trigger: sectionElem,
            start: 'top 20%',
            end: 'bottom 20%',
            scrub: true,
            toggleClass: { targets: link, className: 'is-active' },
          },
        });
      }
    }
  });
});

const employeeList = document.querySelector('.person-info-list');
if (employeeList) {
  // Axios get employee list
  const axiosGetSearchEmployeeList = async (searchTerm, button, departmentSlug) => {
    const formDataInput = {
      action: 'getSearchEmployeeList',
      searchTerm,
      departmentSlug,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      const employeeListWrap = employeeList.querySelector('.person-info-list__row-wrap');
      const employeeListFilter = employeeList.querySelector('.person-info-list__filter');

      if (employeeListWrap && data.data.html_list) {
        employeeListWrap.innerHTML = data.data.html_list;
      }

      if (employeeListFilter && data.data.html_filter) {
        employeeListFilter.innerHTML = data.data.html_filter;
      }

      employeeList.scrollIntoView();

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['searchTerm', 'departmentSlug']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }

    button.disabled = false;
  };

  const employeeListForm = employeeList.querySelector('.person-info-list__form');
  employeeListForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const button = employeeListForm.querySelector('.person-info-list__submit');
    const { value } = employeeListForm.querySelector('.person-info-list__input-field');
    button.disabled = true;

    const checkedDepartment = employeeList.querySelector('.dropdown__list-item input[type="radio"]:checked');
    const departmentSlug = checkedDepartment ? checkedDepartment.getAttribute('data-slug') : '';

    axiosGetSearchEmployeeList(value, button, departmentSlug);
  });

  // Department dropdown
  const dropdownOptions = document.querySelectorAll('.dropdown__list-item input[type="radio"]');
  dropdownOptions.forEach((input) => {
    input.addEventListener('click', () => {
      dropdownOptions.forEach((dropdown) => dropdown.removeAttribute('checked'));

      const departmentSlug = input.getAttribute('data-slug');
      input.setAttribute('checked', '');

      const button = employeeListForm.querySelector('.person-info-list__submit');
      const { value } = employeeListForm.querySelector('.person-info-list__input-field');
      button.disabled = true;

      axiosGetSearchEmployeeList(value, button, departmentSlug);
    });
  });
}
